import Cookies from "universal-cookie";

import { SYSTEM } from "../../../configs";

const cookies = new Cookies();

export const get = (name: string): unknown => {
  return cookies.get(name);
};

export const remove = (name: string): void => {
  cookies.remove(name, { domain: SYSTEM.SESSION_COOKIE_DOMAIN });
};
